<template>
  <div>
    <p>
      {{ itemTypeString !== 'Note' ? $t(itemTypeString) : $t('Unit') }}
      <span v-if="notificationData.curriculumUnitLink" v-html="notificationData.curriculumUnitLink"></span>
      <a v-else :href="getHref"><span v-html="notificationData.name"></span></a>&nbsp;
      <template v-if="notificationType==='Comment'">{{ $t(commentText) }}</template>
      <template v-else-if="notificationType==='PrivateComment'">{{ $t(privateCommentText) }}</template>
      <template v-else>{{ $t(noteText) }}</template>
    </p>
    <p>
      <b v-if="notificationData.subject">{{ notificationData.subject }}:</b>
      {{ notificationData.text }}
    </p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'discussionNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    },
    isNewNotification: {
      type: Boolean,
      required: true
    },
    notificationType: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    itemTypeString: {
      type: String,
      required: true
    }
  },
  computed: {
    commentText () {
      return this.isNewNotification ? 'has a new comment' : 'has a comment'
    },
    privateCommentText () {
      return this.isNewNotification ? 'has a new private comment' : 'has a private comment'
    },
    noteText () {
      return this.isNewNotification ? 'has a new note' : 'has a note'
    },
    getHref () {
      const addUrl = ((this.notificationType === 'PrivateComment') ? 'show-private-comments' : 'show-comments') + '=true'
      if (this.notificationData.link) {
        return this.notificationData.link
      }
      switch (this.itemType) {
        case 'Lesson':
          return '/develop/lesson/' + this.notificationData.id + '/view?' + addUrl
        case 'CurriculumMap':
          return '/Atlas/Develop/View/UnitCalendar?CurriculumMapID=' + this.notificationData.id + '&YearID=' + this.notificationData.yearId + '&EditMode=1&SubNavDevelop=1&' + addUrl
        case 'Unit':
        case 'Note':
        case 'Curriculum':
          return '/Atlas/Develop/UnitMap/View/Default?UnitID=' + this.notificationData.id + '&YearID=' + this.notificationData.yearId + '&EditMode=1&SubNavDevelop=1&' + addUrl
        case 'Report':
          return '/Atlas/View/SavedReport?SavedReportID=' + this.notificationData.id + '&' + addUrl
        default:
          return '/Atlas/Comments/View/Redirect?CommentID=' + this.notificationData.commentId + '&' + addUrl
      }
    }
  }
}
</script>
